import styled from 'styled-components'

import { ButtonBase } from '@components/ui/Buttons'

export const SecondaryLinkButton = styled(ButtonBase)`
  color: ${({ theme }) => theme.colors.blue[40]};
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  background-color: transparent;
  border-color: transparent;

  &:not(:disabled):hover,
  &:not(:disabled):focus:not(:active) {
    background-color: transparent;
    border-color: transparent;
    color: ${({ theme }) => theme.colors.secondary[60]};
  }
`
